import { cn } from "@/lib/utils"

interface SignalsLogoProps {
  className?: string
}

export function SignalsLogo({ className }: SignalsLogoProps) {
  return (
    <img
      src="/signals-logo.png"
      alt=""
      className={cn("size-5 shrink-0", className)}
      aria-hidden="true"
    />
  )
}
